// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { TimeDataUpload } from '@/costs/components/time-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function TimeDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload time data</DialogTitle>
      <DialogContent dividers>
        <TimeDataUpload onClose={props.onClose} onSuccess={props.onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
